import React, { createContext, useContext, useEffect, useRef } from "react";
import { CommandBar, SearchBox, ProgressIndicator } from "@fluentui/react";
import { Empty, notification, Skeleton, Tooltip, Button } from "antd";

import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import WrfmSettingStore from "../../store/wrfmsettingstore";
import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
const wrfmStoreCtx = createContext(WrfmSettingStore);
export const FlowstationFieldList = observer(() => {
  useEffect(() => {
    async function loadMapping() {
      try {
        await wrfmStore.loadMapping();
      } catch (error) {
        notification.error({
          message: "Feedback Manager",

          description: `Something went wrong.${error.message}.`,
        });
      }
    }
    loadMapping();
  }, []);

  const mappingGrid = useRef(null);
  const wrfmStore = useContext(wrfmStoreCtx);
  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 50,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        width: 80,
        checkboxSelection: true,
        pivot: false,
        resizable: true,
      },
      {
        field: "flowstationName",
        headerName: "Flowstation",
        resizable: true,
      },
      {
        field: "fieldName",
        headerName: "Field",
        resizable: true,
      },
      {
        field: "flowstationStatus",
        headerName: "Flowstation Status",
        resizable: true,
      },
      {
        field: "fieldStatus",
        headerName: "Field Status",
        resizable: true,
      },
    ],
  };

  const rowSelected = (grid) => {
    wrfmStore.disableCommand = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) {
      wrfmStore.selMapping = toJS(selrow.data);
      console.log(wrfmStore.selMapping);
    }
  };
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{ borderRight: "1px solid #F0F2F5", marginRight: "5px" }}
    >
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <SubPageHeaderTitle title="Flowstation Field Mappings" />
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            farItems={[
              {
                key: "addbtn",
                onRender: () => (
                  <Tooltip title="Add New flowstation to field mapping">
                    <Button
                      shape="circle"
                      icon={<PlusOutlined />}
                      type="primary"
                      onClick={(ev) => {
                        let initMap = {
                          flowstationId: null,
                          flowstationName: "",
                          fieldId: null,
                          fieldName: "",
                        };

                        wrfmStore.selMapping = initMap;
                        wrfmStore.showMappingDialog = true;
                        wrfmStore.action = "Add";
                      }}
                    />
                  </Tooltip>
                ),
              },
            ]}
          ></CommandBar>
        </div>
      </div>

      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <div className="ms-Grid" dir="ltr">
            {wrfmStore.isLoading && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <ProgressIndicator
                    description="processing, please wait..."
                    styles={{ root: { textAlign: "center" } }}
                  ></ProgressIndicator>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "filtert356",

                text: "Modify Mapping",
                disabled: wrfmStore.disableCommand,
                onClick: (ev) => {
                  wrfmStore.showMappingDialog = true;
                  wrfmStore.action = "Modify";
                },
              },
              {
                key: "filtertj",

                text: "Remove Mapping",
                disabled: true, // wrfmStore.disableCommand,
              },
              {
                key: "spacere",
                onRender: () => <div style={{ width: "150px" }} />,
              },
              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the production data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        mappingGrid.current.api.setQuickFilter(searchTerms);
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
            ]}
            farItems={[
              {
                key: "group4",

                text: (
                  <Tooltip title="Export displayed production data to excel">
                    Export to Excel
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: async () => {
                  try {
                    wrfmStore.isLoading = true;
                    await mappingGrid.current.api.exportDataAsExcel({
                      sheetName: "Flowstation field mappings",
                      allColumns: true,
                      columnGroups: true,
                      skipFooters: false,
                      skipGroups: false,
                      skipHeader: false,
                      skipPinnedTop: false,
                      skipPinnedBottom: false,
                      fileName: "flowstation_field_mappings",
                      skipColumnGroupHeaders: false,
                      skipColumnHeaders: false,
                      columnGroups: true,
                    });
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: "export failed",
                    });
                  } finally {
                    wrfmStore.isLoading = false;
                  }
                },
              },
            ]}
          />
        </div>
      </div>

      {wrfmStore.isLoading ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <div
          className="ag-theme-balham"
          style={{
            minHeight: "50vh",
            height: "70vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {wrfmStore.flowstationfields.size > 0 ? (
            <AgGridReact
              ref={mappingGrid}
              rowData={[...wrfmStore.flowstationfields.values()]}
              onSelectionChanged={rowSelected}
              columnDefs={gridcolumnDefs.columnDefs}
              gridOptions={{
                defaultColDef: {
                  sortable: true,
                  filter: true,
                  enableValue: true,
                  enableRowGroup: true,
                  enablePivot: true,
                },
                enableCharts: true,
                enableRangeSelection: true,

                rowSelection: "single",
                pagination: true,
                columnDefs: gridcolumnDefs.columnDefs,
                animateRows: true,
                statusBar: {
                  statusPanels: [
                    {
                      statusPanel: "agTotalRowCountComponent",
                      align: "center",
                    },
                  ],
                },
                columnTypes: {
                  numberColumn: {
                    width: 130,
                    filter: "agNumberColumnFilter",
                  },
                  medalColumn: {
                    width: 100,
                    columnGroupShow: "open",
                    filter: false,
                  },
                  nonEditableColumn: { editable: false },
                  dateColumn: {
                    filter: "agDateColumnFilter",
                    filterParams: {
                      comparator: function (
                        filterLocalDateAtMidnight,
                        cellValue
                      ) {
                        var dateParts = cellValue.split("/");
                        var day = Number(dateParts[0]);
                        var month = Number(dateParts[1]) - 1;
                        var year = Number(dateParts[2]);
                        var cellDate = new Date(year, month, day);
                        if (cellDate < filterLocalDateAtMidnight) {
                          return -1;
                        } else if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        } else {
                          return 0;
                        }
                      },
                    },
                  },
                },
              }}
              rowSelection="single"
              copyHeadersToClipboard={true}
              overlayLoadingTemplate={`${(
                <span class="ag-overlay-loading-center">
                  Please wait while your rows are loading
                </span>
              )}`}
              overlayNoRowsTemplate={
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result</span>'
              }
            ></AgGridReact>
          ) : (
            <Empty />
          )}
        </div>
      )}
    </div>
  );
});

